<template>
  <section class="w-full h-full flex overflow-hidden" v-loading="loading">
    <div class="flex-1 flex flex-col overflow-hidden">
      <div class="flex-1 p-4 box-border overflow-hidden">
        <process-content v-if="isTestQuestion"/>
        <initialize v-else/>
      </div>
      <footer
        v-if="isTestQuestion && topSource.currentView < topSource.MAXACTIVE + 1"
        class="w-full h-14 px-4 box-border flex items-center justify-end bg-white shadow-theme"
      >
        <el-button type="primary" size="small" :loading="topSource.nextLoading" @click="nextStepHandle">
          下一步
        </el-button>
      </footer>
    </div>
    <aside v-if="isShowcontactUs || isTestQuestion" class="w-290px bg-white border-l border-solid border-border-gray overflow-auto">
      <aside-dimension-score v-if="isTestQuestion"/>
      <aside-contact-us v-custom:dimension-score="'wj_F127'" />
    </aside>
  </section>
</template>

<script>
import { getAllQuestion } from '@/api/wenjuan/dimensionScore'
import Initialize from './components/dimension-score/Initialize';
import ProcessContent from './components/dimension-score/ProcessContent';
import AsideDimensionScore from './components/dimension-score/AsideDimensionScore';
import AsideContactUs from './components/dimension-score/AsideContactUs';

export default {
  name: 'DimensionScore',
  components: {
    Initialize,
    ProcessContent,
    AsideDimensionScore,
    AsideContactUs
  },
  provide() {
    return {
      topSource: this.topSource,
      setFullActive: this.setFullActive,
    }
  },
  data() {
    return {
      loading: false,
      topSource: {
        MAXACTIVE: 3,
        onNextBefore: null,
        onStepBefore: null,
        nextLoading: false,
        active: 0,
        currentView: 1,
        questions: [],
        // 维度计算方式
        computeMode: 0,
        // 标准分权重状态设置
        standardValue: false,
        weightValue: false,
        // 答题结束后显示报告
        showReportAfterAnswer: false,
        // 测评说明
        instruction: ''
      }
    }
  },
  computed: {
    isTestQuestion() {
      return this.topSource.questions.length > 0;
    },
    isShowcontactUs(){
      return this.$store.getters.configContextMap.get('dimension-score')?.wj_F127 === '1'
    }
  },
  mounted() {
    this.getTestQuestion();
    this.addEvent();
  },
  beforeDestroy() {
    this.removeEvent();
  },
  methods: {
    addEvent() {
      this.sb = this.$surveyBus.$on('showDraft', this.eventHandle);
    },
    removeEvent() {
      if (this.sb) {
        this.sb.$off('showDraft', this.eventHandle);
      }
    },
    eventHandle(bool) {
      if (!bool) {
        this.getTestQuestion();
      }
    },
    getTestQuestion() {
      this.loading = true;
      getAllQuestion().then((res) => {
        const list = res.data.data || [];
        this.topSource.questions = list.map((m,i) => ({ ...m, orderIndex: i + 1 }));
      }).catch(() => {
        this.$message.error('获取问卷问题列表失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    setFullActive() {
      this.topSource.active = this.topSource.MAXACTIVE + 1;
    },
    nextStep() {
      if (this.topSource.currentView < this.topSource.MAXACTIVE + 1) {
        this.topSource.currentView++;
      }
      this.topSource.onNextBefore = null;
    },
    nextStepHandle() {
      const isFn = typeof this.topSource.onNextBefore === 'function';
      if (isFn) {
        const isNext = this.topSource.onNextBefore();
        if (Object.prototype.toString.call(isNext) === '[object Promise]') {
          isNext.then(() => {
            this.nextStep();
          }).catch(() => {});
        } else if (isNext) {
          this.nextStep();
        }
      } else {
        this.nextStep();
      }
    }
  }
}
</script>